var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.5v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2h5a1 1 0 1 1 0 2h-1v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-12H1a1 1 0 0 1 0-2h5Zm-2 2v12h12v-12H4Zm8-2v-2H8v2h4Zm-4 4a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Z",
    fill: "#999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGray);
export default __webpack_public_path__ + "static/media/trash-gray.de40e2a3bc2b6884683fedd99e0a0ea5.svg";
export { ForwardRef as ReactComponent };